/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import MedicalConditionType from 'linced-app/enums/medical-condition-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { classNameBindings } from '@ember-decorators/component';

@classNameBindings(
  'condition.currentState.isDirty:md-dirty',
  'condition.isCurrent::medical-condition-expired',
)
export default class MedicalConditionCard extends Component {
  // Services
  @service
  options;

  @service
  permissions;

  @service
  session;

  @service
  store;

  @service
  toaster;

  Jurisdiction = Jurisdiction;
  MedicalConditionType = MedicalConditionType;
  Scopes = Scopes;

  @alias('session.school.jurisdiction')
  jurisdiction;

  editable = true;
  removable = true;

  @computed('session.user.roles')
  get hasAdminAccess() {
    return this.session.user.roles.includes('adminsite:fullaccess');
  }

  @computed('session.scopes.[]')
  get isTenantAdmin() {
    return this.permissions.meet(Scopes.TENANT_ADMIN);
  }

  @optionAlias('core:staffPermissions:medicationsForTeachers')
  medicationsForTeachers;

  @computed('isTenantAdmin', 'medicationsForTeachers')
  get canAdministerMedications() {
    return this.isTenantAdmin || this.medicationsForTeachers;
  }

  condition = null;

  @alias('condition.description')
  description;

  @alias('condition.fields.core:subtype.value')
  subtype;

  @computed('condition.{anaphylaxis,highRisk}')
  get alertTooltip() {
    let alerts = [];
    if (this.get('condition.anaphylaxis')) {
      alerts.push('Anaphylaxis');
    }
    if (this.get('condition.highRisk')) {
      alerts.push('High Risk');
    }
    return alerts.join(', ');
  }

  autoinjectorLabel = 'Adrenaline Autoinjector Held Onsite';
  actionPlansField = null;
  subtypeField = null;
}
